import React, { useState } from "react";
import { Formik, Form } from "formik";
import { createTemplateSchema } from "../../../Schemas/Email Marketing/email_marketing_schema";
import { Toast } from "../../../CustomComponent/toast";
import CustomInput from "../../../CustomComponent/custom_input";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import performRequest from "../../../api/request";
import { useLocation, useNavigate } from "react-router";
import SimpleButton from "../../../Components/layouts/simple_button";
const defaultTemplate = `<div><div><!-- Full Page Container -->
<div style="text-align: center; margin: 10px 0;">
  <img src="https://kryzen.com/wp-content/uploads/2022/02/kryzen-logo-1.png" alt="Kryzen Logo" style="max-width: 100%; height: auto;">
</div>

<!-- Main Email Container -->
<div style="margin: 20px auto; max-width: 600px; background-color: #ffffff; border-radius: 10px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); overflow: hidden;">
  <!-- Header Section -->
  <div style="text-align: center; background-color: #89CFF0; color: #ffffff; padding: 20px;">
    <h1 style="margin: 0; font-size: 24px;">Unlock the Future of Farming: Get Flat ₹200 Off on Our Hydroponic Masterclass!</h1>
  </div>

  <!-- Content Section -->
  <div style="padding: 20px; color: #666666;">
    <p>Hello <strong>{{RecipientName}}</strong>,</p>
    <p>
      Kryzen Biotech is excited to announce the launch of our exclusive <strong>Hydroponic Masterclass</strong>! Whether you're a beginner or an enthusiast looking to elevate your knowledge, this comprehensive course is your gateway to mastering the future of farming.
    </p>
    <p>
      As a valued subscriber, we’re offering you a <strong>flat ₹200 discount</strong> on your registration!
    </p>
    <p>Here’s what you’ll learn:</p>
    <ul style="color: #666666; padding-left: 20px;">
      <li>✔ Fundamentals of Hydroponics</li>
      <li>✔ Setting Up a System on Any Scale</li>
      <li>✔ Best Practices for High-Yield Growth</li>
      <li>✔ Expert Tips for Maximizing ROI</li>
    </ul>
    <p>
      <strong>Enroll Now and Save ₹200!</strong>
    </p>
    <p>
      But hurry—this special offer is available only until <strong>31-12-2024</strong>.
    </p>

    <div style="text-align: center; margin: 30px 0;">
      <a href="https://www.hydroponicmasterclass.com/" style="background-color: #1e90ff; color: #ffffff; padding: 15px 30px; text-decoration: none; border-radius: 5px; font-size: 16px;">Claim Your Discount &amp; Enroll Now</a>
    </div>

    <p>
      For more inquiries about the Hydroponic Masterclass, contact us at <strong>9870-424-425</strong> or email us at <strong>contact@kryzen.com</strong>.
    </p>

    <p>
      Best regards,<br>
      <strong>The Kryzen Biotech Team</strong>
    </p>
  </div>

  <!-- Footer Section -->
  <div style="text-align: center; background-color: #f4f4f8; padding: 10px;">
    <p style="margin: 0; font-size: 12px; color: #666666;">© 2024 Kryzen Biotech</p>
    <a href="https://kryzen.com/" style="font-size: 12px; color: #666666; text-decoration: none;">unsubscribe</a>
  </div>
</div>
</div></div>`;

const Createemailtemplate = () => {
  const [htmlContent, setHtmlContent] = useState("");
  // const [cssContent, setCssContent] = useState("");
  const navigate = useNavigate();
  const handleHtmlChange = (e) => {
    setHtmlContent(e.target.value);
  };
  const location = useLocation();

  // const handleCssChange = (e) => {
  //   setCssContent(e.target.value);
  // };

  const createTemplate = (values, props) => {
    let d = document.getElementById("getData");
    const requestData = {
      TemplateContent: {
        Html: d.innerHTML, // Replace with actual HTML content if available
        Subject: values.subjectPart, // Replace with actual subject
        Text: "", // Replace with actual text content
      },
      TemplateName: values.templateName, // Using template name from Formik values
    };

    if (d) {
      performRequest("POST", `/bulkemail/create-ses-template/`, requestData)
        .then((res) => {
          if (res.status === 200) {
            Toast("success", res.data.message);
            navigate(`/email-marketing${location?.search}`);
          }
        })
        .catch((err) => {
          console.error(err);
          Toast("error", err.response.data.error.message);
        });
    }
  };

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-body">
            <div className="card-header"></div>
            <div className="card">
              <div className="card-body">
                <div className="card-title">TemplateOne</div>
                <Formik
                  initialValues={{ templateName: "", subjectPart: "" }}
                  validationSchema={createTemplateSchema}
                  onSubmit={createTemplate}
                  enableReinitialize
                >
                  {(props) => (
                    <Form>
                      <div className="modal-body">
                        <div className="card-body">
                          {/* Template Name */}
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3 required">
                              Enter Template Name:
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="templateName" type="text" />
                              {props.touched.templateName &&
                                props.errors.templateName && (
                                  <p className="text-danger">
                                    {props.errors.templateName}
                                  </p>
                                )}
                            </div>
                          </div>

                          {/* Subject */}
                          <div className="mb-3 row">
                            <label className="w-25 form-label col-3 required">
                              Enter Subject:
                            </label>
                            <div className="w-100 col">
                              <CustomInput name="subjectPart" type="text" />
                              {props.touched.subjectPart &&
                                props.errors.subjectPart && (
                                  <p className="text-danger">
                                    {props.errors.subjectPart}
                                  </p>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Live HTML and CSS Editor */}
                      <div className="row col-12">
                        <div className="col-12 badge text-start text-black bg-lime p-2 rounded">
                          <span>&#x2139;</span> Please Add
                          &#123;&#123;RecipientName&#125;&#125; for Dynamic User
                          Name write same as it is mention
                        </div>
                        <div className="container-fluid vh-100 d-flex p-3">
                          {/* Editor Area */}
                          <div className="col-6 d-flex flex-column gap-3">
                            <textarea
                              className="form-control flex-grow-1"
                              value={
                                htmlContent ? htmlContent : defaultTemplate
                              }
                              onChange={handleHtmlChange}
                              placeholder="Write your HTML here..."
                            />
                            {/* <textarea
                              className="form-control flex-grow-1"
                              value={cssContent}
                              onChange={handleCssChange}
                              placeholder="Write your CSS here..."
                            /> */}
                          </div>

                          {/* Preview Area */}
                          <div
                            id="getData"
                            className="col-6 border rounded p-3 bg-light overflow-auto"
                          >
                            {/* <style>{cssContent}</style> */}
                            {htmlContent ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: htmlContent,
                                }}
                              ></div>
                            ) : (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: defaultTemplate,
                                }}
                              ></div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Footer with Submit Button */}
                      <div className="modal-footer">
                        <FormSubmitButton buttonText="Create Template" />
                        <SimpleButton buttonText="Cancel" type="secondary" />
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Createemailtemplate;
